import React from "react"
import ReactDOM from "react-dom"
import { Provider as ReduxProvider } from "react-redux"
import configureStore from "./store"
import "./styles/page.scss"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import * as Sentry from "@sentry/react"
if (process.env.REACT_APP_ENV === "production") {
  serviceWorker.unregister()
} else {
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: http://bit.ly/CRA-PWA
  serviceWorker.register()
}

var store = configureStore()
store.subscribe(() => {
  if (process.env.NODE_ENV === "development") {
  }
})

ReactDOM.render(
  <Sentry.ErrorBoundary showDialog>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </Sentry.ErrorBoundary>,
  document.getElementById("root")
)
